import React from "react";
import { Link } from "react-router-dom";
import useArtisanContext from "../../hooks/useArtisanContext";

const SearchDropdown = ({ searchTerm }) => {
  const {
    closestArtisan,
    fixOFTheMonth,
    category: featureCategory,
    getByCategory,
    getProviderDetail,
  } = useArtisanContext();

  if (!searchTerm) {
    return null;
  }

  const combinedArtisans = [
    ...(closestArtisan || []),
    ...(fixOFTheMonth || []),
  ];

  const uniqueArtisans = combinedArtisans.reduce((acc, current) => {
    const x = acc.find((item) => item.id === current.id);
    if (!x) {
      return acc.concat([current]);
    } else {
      return acc;
    }
  }, []);

  const filteredArtisans = uniqueArtisans.filter((artisan) => {
    const businessName = artisan?.business_name?.toLowerCase() || "";
    const categoryName =
      artisan?.service_category?.category?.toLowerCase() || "";
    const searchTermLower = searchTerm.toLowerCase();

    return (
      businessName.includes(searchTermLower) ||
      categoryName.includes(searchTermLower)
    );
  });

  const filteredCategories = (featureCategory || []).filter((category) => {
    const categoryName = category?.category?.toLowerCase() || "";
    const searchTermLower = searchTerm.toLowerCase();

    return categoryName.includes(searchTermLower);
  });

  if (filteredArtisans.length === 0 && filteredCategories.length === 0) {
    return (
      <div className="absolute z-50 mt-1 w-full bg-white shadow-lg rounded-md p-4">
        <div className="text-center text-gray-500">
          <p>No results found for "{searchTerm}"</p>
          <p className="text-xs mt-1">Try searching for something else</p>
        </div>
      </div>
    );
  }

  return (
    <div className="absolute z-50 mt-1 w-full bg-white shadow-lg rounded-md max-h-60 overflow-auto">
      {/* Categories Section */}
      {filteredCategories.length > 0 && (
        <div className="border-b border-gray-100">
          <div className="px-3 py-2 text-xs font-semibold text-gray-500 uppercase tracking-wider">
            Categories
          </div>
          {filteredCategories.map((category) => (
            <button
              key={category.id}
              onClick={() => getByCategory(category?.id)}
              className="flex items-center p-3 hover:bg-gray-100 w-full"
            >
              <div className="w-10 h-10 rounded-full bg-gray-200 flex items-center justify-center mr-3">
                <span className="text-gray-500 text-lg">📁</span>
              </div>
              <div>
                <p className="font-medium text-sm">{category.category}</p>
              </div>
            </button>
          ))}
        </div>
      )}

      {/* Artisans Section */}
      {filteredArtisans.length > 0 && (
        <div>
          <div className="px-3 py-2 text-xs font-semibold text-gray-500 uppercase tracking-wider">
            Artisans
          </div>
          {filteredArtisans.map((artisan) => (
            <Link
              key={artisan.id}
              onClick={() => {
                getProviderDetail(artisan?.id);
              }}
              className="flex items-center p-3 hover:bg-gray-100 border-b border-gray-100 last:border-b-0"
            >
              <img
                src={artisan.image}
                alt={artisan.business_name}
                className="w-10 h-10 rounded-full object-cover mr-3"
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = "https://via.placeholder.com/40";
                }}
              />
              <div>
                <p className="font-medium text-sm">{artisan.business_name}</p>
                <p className="text-xs text-gray-500">
                  {artisan.service_category?.category}
                </p>
              </div>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
};

export default SearchDropdown;
